import apiClient from "./apiClient";

export function listVendorsRequest(params = {}) {
  return apiClient.get("/vendors", { params });
}

export function getVendorRequest(vendorId) {
  return apiClient.get(`/vendors/${vendorId}`);
}

export function createVendorRequest(payload) {
  return apiClient.post("/vendors", payload);
}

export function updateVendorRequest(vendorId, payload) {
  return apiClient.patch(`/vendors/${vendorId}`, payload);
}

export function deleteVendorRequest(vendorId) {
  return apiClient.delete(`/vendors/${vendorId}`);
}
